module.exports = {
      id: "twittercolorround-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "svg-sprite-3da3c54197bd9bf6e26a7217bd920efb.svg#twittercolorround",
      toString: function () {
        return this.url;
      }
    }